module.exports = __webpack_public_path__ + "img/kind_2.0fab7a0b.jpg";